// extracted by mini-css-extract-plugin
export var dataCell = "_mu-2";
export var dataRow = "_mu-0";
export var headerRow = "_mu-1";